import { gql } from '@apollo/client'
import { graphql } from '../../graphql-setup'

export const EXPORT_MATERIALS = graphql(`
  mutation ExportMaterialFilledOutForms(
    $company: ID!
    $exportType: String!
    $exportFormat: ExportFormat
    $exportOption: ExportOption
    $formTemplateId: ID!
  ) {
    exportMaterialFilledOutForms(
      company: $company
      exportType: $exportType
      exportFormat: $exportFormat
      exportOption: $exportOption
      formTemplateId: $formTemplateId
    ) {
      ok
      html
      exportTimeout
    }
  }
`)

export const EXPORT_EQUIPMENTS = graphql(`
  mutation ExportVehicles(
    $company: ID!
    $exportType: String!
    $exportFormat: ExportFormat
    $exportOption: ExportOption
  ) {
    exportVehicles(
      company: $company
      exportType: $exportType
      exportFormat: $exportFormat
      exportOption: $exportOption
    ) {
      ok
      html
      exportTimeout
    }
  }
`)

export const CREATE_VEHICLE_MUTATION = gql`
  mutation CreateVehicle($input: CreateVehicleInput!) {
    createVehicle(input: $input) {
      vehicle {
        id
      }
    }
  }
`

export const CREATE_DUMMY_VEHICLE_MUTATION = gql`
  mutation CreateDummyVehicle($name: String!) {
    createDummyVehicle(name: $name) {
      vehicle {
        id
        name
      }
    }
  }
`

export const CREATE_VEHICLE_BY_REGISTRATION_NUMBER_MUTATION = gql`
  mutation CreateVehicleByRegistrationNumber(
    $input: CreateVehicleByRegistrationNumberInput!
  ) {
    createVehicleByRegistrationNumber(input: $input) {
      vehicle {
        id
      }
    }
  }
`

export const DEACTIVATE_VEHICLE_MUTATION = graphql(`
  mutation DeactivateVehicle($id: ID!) {
    deactivateVehicle(id: $id) {
      ok
    }
  }
`)

export const DELETE_VEHICLE_MUTATION = gql`
  mutation DeleteVehicle($id: ID!) {
    deleteVehicle(id: $id) {
      deletedId
    }
  }
`

export const ADD_DIESEL_CARD = gql`
  mutation AddDieselCard($input: CreateDieselCardInput!) {
    createDieselCard(input: $input) {
      dieselCard {
        id
        number
        pinCode
      }
    }
  }
`

export const UPDATE_DIESEL_CARD = gql`
  mutation UpdateDieselCard($id: ID!, $input: PatchDieselCardInput!) {
    updateDieselCard(id: $id, input: $input) {
      dieselCard {
        id
        number
        pinCode
      }
    }
  }
`

export const DELETE_DIESEL_CARD = gql`
  mutation DeleteDieselCard($id: ID!) {
    deleteDieselCard(id: $id) {
      found
    }
  }
`

export const PATCH_VEHICLE_MUTATION = gql`
  mutation PatchVehicle($id: ID!, $input: PatchVehicleInput!) {
    patchVehicle(id: $id, input: $input) {
      vehicle {
        id
      }
    }
  }
`

export const CREATE_VEHICLE_DOCUMENT_MUTATION = gql`
  mutation CreateVehicleDocument($input: CreateVehicleDocumentInput!) {
    createVehicleDocument(input: $input) {
      vehicleDocument {
        id
        name
        originalName
      }
    }
  }
`
export const PATCH_VEHICLE_DOCUMENT_MUTATION = gql`
  mutation PatchVehicleDocument($id: ID!, $input: PatchVehicleDocumentInput!) {
    patchVehicleDocument(id: $id, input: $input) {
      vehicleDocument {
        id
      }
    }
  }
`

export const DELETE_VEHICLE_DOCUMENT_MUTATION = gql`
  mutation DeleteVehicleDocument($id: ID!) {
    deleteVehicleDocument(id: $id) {
      deletedId
    }
  }
`

export const CREATE_VEHICLE_EXPIRATION_MUTATION = gql`
  mutation CreateVehicleExpiration($input: CreateVehicleExpirationInput!) {
    createVehicleExpiration(input: $input) {
      vehicleExpiration {
        id
        expirationType {
          id
        }
        expirationDate
      }
    }
  }
`

export const PATCH_VEHICLE_EXPIRATION_MUTATION = gql`
  mutation PatchVehicleExpiration(
    $id: ID!
    $input: PatchVehicleExpirationInput!
  ) {
    patchVehicleExpiration(id: $id, input: $input) {
      vehicleExpiration {
        id
      }
    }
  }
`

export const DELETE_VEHICLE_EXPIRATION_MUTATION = gql`
  mutation DeleteVehicleExpiration($id: ID!) {
    deleteVehicleExpiration(id: $id) {
      deletedId
    }
  }
`

export const CREATE_VEHICLE_SERVICE_PLAN_MUTATION = gql`
  mutation CreateVehicleServicePlan($input: CreateVehicleServicePlanInput!) {
    createVehicleServicePlan(input: $input) {
      vehicleServicePlan {
        id
        name
        scheduledStart
      }
    }
  }
`

export const PATCH_VEHICLE_SERVICE_PLAN_MUTATION = gql`
  mutation PatchVehicleServicePlan(
    $id: ID!
    $input: PatchVehicleServicePlanInput!
  ) {
    patchVehicleServicePlan(id: $id, input: $input) {
      vehicleServicePlan {
        id
      }
    }
  }
`

export const DELETE_VEHICLE_SERVICE_PLAN_MUTATION = gql`
  mutation DeleteVehicleServicePlan($id: ID!) {
    deleteVehicleServicePlan(id: $id) {
      deletedId
    }
  }
`

export const CONVERT_VEHICLE_EXPIRATION_TO_SERVICE_PLAN_MUTATION = gql`
  mutation ConvertVehicleExpirationToServicePlan($id: ID!) {
    convertVehicleExpirationToServicePlan(id: $id) {
      servicePlan {
        id
        name
      }
    }
  }
`

export const CONVERT_VEHICLE_SERVICE_PLAN_TO_EXPIRATION_MUTATION = gql`
  mutation ConvertVehicleServicePlanToExpiration($id: ID!) {
    convertVehicleServicePlanToExpiration(id: $id) {
      expiration {
        id
        description
      }
    }
  }
`

export const CREATE_VEHICLE_EXPIRATION_TYPE_MUTATION = gql`
  mutation CreateVehicleExpirationType(
    $input: CreateVehicleExpirationTypeInput!
  ) {
    createVehicleExpirationType(input: $input) {
      vehicleExpirationType {
        id
        name
      }
    }
  }
`

export const PATCH_VEHICLE_EXPIRATION_TYPE_MUTATION = gql`
  mutation PatchVehicleExpirationType(
    $id: ID!
    $input: PatchVehicleExpirationTypeInput!
  ) {
    patchVehicleExpirationType(id: $id, input: $input) {
      vehicleExpirationType {
        id
        name
      }
    }
  }
`

export const DELETE_VEHICLE_EXPIRATION_TYPE_MUTATION = gql`
  mutation DeleteVehicleExpirationType($id: ID!) {
    deleteVehicleExpirationType(id: $id) {
      found
      deletedId
    }
  }
`

export const CREATE_VEHICLE_NOTE_MUTATION = gql`
  mutation CreateVehicleNote($input: CreateVehicleNoteInput!) {
    createVehicleNote(input: $input) {
      vehicleNote {
        id
      }
    }
  }
`

export const PATCH_VEHICLE_NOTE_MUTATION = gql`
  mutation PatchVehicleNote($id: ID!, $input: PatchVehicleNoteInput!) {
    patchVehicleNote(id: $id, input: $input) {
      vehicleNote {
        id
      }
    }
  }
`

export const DELETE_VEHICLE_NOTE_MUTATION = gql`
  mutation DeleteVehicleNote($id: ID!) {
    deleteVehicleNote(id: $id) {
      deletedId
    }
  }
`

/**
 * Exporting one of the fleet-wide vehicle lists. Each takes the same filter
 * arguments as the list query it belongs to, so the export contains exactly the
 * rows the page is showing.
 */
export const EXPORT_VEHICLE_DOCUMENTS_MUTATION = gql`
  mutation ExportVehicleDocuments(
    $exportFormat: ExportFormat
    $exportOption: ExportOption!
    $filters: VehicleDocumentExportFilterInput
  ) {
    exportVehicleDocuments(
      exportFormat: $exportFormat
      exportOption: $exportOption
      filters: $filters
    ) {
      ok
      html
      exportTimeout
    }
  }
`

export const EXPORT_VEHICLE_EXPIRATIONS_MUTATION = gql`
  mutation ExportVehicleExpirations(
    $exportFormat: ExportFormat
    $exportOption: ExportOption!
    $filters: VehicleExpirationExportFilterInput
  ) {
    exportVehicleExpirations(
      exportFormat: $exportFormat
      exportOption: $exportOption
      filters: $filters
    ) {
      ok
      html
      exportTimeout
    }
  }
`

export const EXPORT_VEHICLE_SERVICE_PLANS_MUTATION = gql`
  mutation ExportVehicleServicePlans(
    $exportFormat: ExportFormat
    $exportOption: ExportOption!
    $filters: VehicleServicePlanExportFilterInput
  ) {
    exportVehicleServicePlans(
      exportFormat: $exportFormat
      exportOption: $exportOption
      filters: $filters
    ) {
      ok
      html
      exportTimeout
    }
  }
`
